<template>
  <b-row class="m-0" v-if="indexFile == active">
    <b-col
      class="p-md-2 text-break"
      cols="12"
      sm="6"
      md="6"
      v-text="`${$lang.attachment_type}: `"
    />
    <b-col
      class="p-md-2 text-break"
      cols="12"
      sm="6"
      md="6"
      v-text="pathOr('', ['attachment_type', 'caption'], file)"
    />

    <b-col
      class="p-md-2 text-break"
      cols="12"
      sm="6"
      md="6"
      v-text="`${$lang.caption}: `"
    />
    <b-col
      class="p-md-2 text-break"
      cols="12"
      sm="6"
      md="6"
      v-text="file.caption"
    />
    <b-col
      class="p-md-2 text-break"
      cols="12"
      sm="6"
      md="6"
      v-text="`${$lang.detailsPriview.size}: `"
    />
    <b-col
      class="p-md-2 text-break"
      cols="12"
      sm="6"
      md="6"
      v-text="bytesToSize(file.size)"
    />
    <b-col
      class="p-md-2 text-break"
      cols="12"
      sm="6"
      md="6"
      v-text="`${$lang.detailsPriview.created_at}: `"
    />
    <b-col
      class="p-md-2 text-break dir_ltr"
      cols="12"
      sm="6"
      md="6"
      v-if="file.created_at"
      v-text="pathOr('', ['created_at', 'jalali'], file)"
    />
    <b-col
      class="p-md-2 text-break"
      cols="12"
      sm="6"
      md="6"
      v-text="`${$lang.detailsPriview.file_name}: `"
    />
    <b-col
      class="p-md-2 text-break"
      cols="12"
      sm="6"
      md="6"
      v-text="spliceName(file.name)"
    />
    <b-col
      class="p-md-2 text-break"
      cols="12"
      sm="6"
      md="6"
      v-text="`${$lang.detailsPriview.file_format}: `"
    />
    <b-col
      class="p-md-2 text-break"
      cols="12"
      sm="6"
      md="6"
      v-text="file.ext"
    />

    <b-col
      v-if="file.confirm_type && file.confirm_type.id !== 1"
      class="p-md-2 text-break"
      cols="12"
      sm="12"
      md="12"
    >
      <label for="">{{ $lang.detailsPriview.link }} </label>
      <div class="link-copy" ref="text">
        <span
          class="cursor-pointer icon-link-copy"
          @click="copy"
          v-b-tooltip.hover
          :title="$lang.detailsPriview.clipboard"
          ><i class="fa fa-clipboard" aria-hidden="true"></i
        ></span>
        <b-form-input
          class="input-link"
          dir="ltr"
          :value="file.url"
        ></b-form-input>
      </div>
    </b-col>
    <b-col
      v-if="file.confirm_type && file.confirm_type.id !== 1"
      class="my-2 p-2"
      cols="12"
      sm="12"
      md="12"
    >
      <div
        class="text-danger px-2 cursor-pointer float-left"
        @click="removeFile(file)"
      >
        {{ $lang.detailsPriview.file_deleted }}
      </div>
      <a class="px-2 float-right" :href="file.url">{{
        $lang.detailsPriview.download
      }}</a>
    </b-col>
  </b-row>
</template>

<script>
import { pathOr } from "ramda";
import { isAdmin } from "@/shared/utils";

/**
 * @group detailPriview
 * این کامپوننت برای نمایش فایل جزءیات فایل تعریف شده است
 */
export default {
  name: "detail-priview", // نام کامپوننت
  props: {
    // ابجکت قایل
    file: {
      type: Object,
      default: () => {},
    },
    // جایگاه ابجکت فایل
    indexFile: {
      type: Number,
      default: 0,
    },
    // نمایش فایل کلیک شده
    active: {
      type: Number,
      default: 0,
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    pathOr,
    isAdmin,
    spliceName(name) {
      if (name) return name.split(".")[0];
    },
    /**
     * @vuese
     * 	برای تبدیل حجم فایل
     *  @arg  یارامتر ارسالی  به نام bytes که عدد می باشد
     */
    bytesToSize(bytes) {
      if (!bytes) return "0";
      let seperator = "";
      let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "n/a";
      let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
      if (i === 0) return `${bytes}${seperator}${sizes[i]}`;
      return `${(bytes / 1024 ** i).toFixed(1)}${seperator}${sizes[i]}`;
    },
    /**
     * @vuese
     * 	برای کپی پیوند
     *  @arg  یارامتر ارسالی  به نام element
     */
    selectText(element) {
      var range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    /**
     * @vuese
     * 	برای کپی پیوند
     *  @arg بدون پارامتر
     */
    copy() {
      navigator.clipboard.writeText(this.file.url);
      this.selectText(this.$refs.text);
      document.execCommand("copy");
      this.$notify.success(this.$lang.linkCopy);
    },
    /**
     * @vuese
     * 	برای کپی پیوند
     *  @arg آبجکت فایل ورودی
     */
    removeFile(file) {
      this.$emit("removeFile", file);
    },
  },
};
</script>
<style>
.input-link {
  width: 95%;
}

.link-copy {
  cursor: pointer;

  word-break: break-all;
  position: relative;
}

.icon-link-copy {
  position: absolute;
  left: -6px;
  top: 9px;
}

.border-top {
  border-top: 1px solid lightgray;
  padding-top: 5px;
  margin-top: 5px;
}

.cursor-pointer {
  cursor: pointer;
  text-decoration: none;
}

.text-break {
  word-break: break-all;
}
</style>
